import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { DSIconElement } from '@saucelabs/ds-icons';
import { mergeProps, useButton, useFocusVisible } from 'react-aria';
// eslint-disable-next-line import/no-unresolved
import { AriaButtonProps } from '@react-types/button';
import classnames from 'classnames';

export const DiffViewMenuButton = forwardRef<
  HTMLButtonElement,
  DiffViewMenuButtonProps
>((props, forwardedRef) => {
  const { icon: Icon, label, isActive, isDisabled, isHidden, ...other } = props;

  const { isFocusVisible } = useFocusVisible();
  const ref = useRef<HTMLButtonElement>(null);
  useImperativeHandle<HTMLButtonElement | null, HTMLButtonElement | null>(
    forwardedRef,
    () => ref.current,
  );
  const { buttonProps, isPressed } = useButton(props, ref);

  return (
    <button
      ref={ref}
      aria-label={label}
      className={classnames(
        'appearance-none border-none bg-white hover:bg-gray-50 p-1.5 rounded fill-current',
        'focus:outline-none ring-blue-100 cursor-pointer',
        {
          'focus:ring': isFocusVisible,
          'bg-gray-100 hover:bg-gray-100': isPressed,
          'text-gray-600': !isActive && !isDisabled,
          'text-blue-800': isActive && !isDisabled,
          'text-gray-200': isDisabled,
          hidden: isHidden,
        },
      )}
      type="button"
      {...mergeProps(buttonProps, other)}
    >
      <Icon className="w-2 h-2" />
    </button>
  );
});

export interface DiffViewMenuButtonProps extends AriaButtonProps {
  isActive?: boolean;
  isHidden?: boolean;
  icon: DSIconElement;
  label: string;
}
